module.exports = __webpack_public_path__ + "img/panel2.833df386.jpg";